module.exports = "/legacy/21d95410f660ccd52279b82b2de59a72.svg";